import CustomFormGenerated from '../elements/CustomFormGenerated'
import React from 'react'

function FormGenerator(props) {
  const { formGen = [], form, data, column } = props
  return (
    <div>
      {formGen.map(item => (
        <CustomFormGenerated
          {...{
            form,
            data,
            column,
            ...item,
          }}
        />
      ))}
    </div>
  )
}

export default FormGenerator
